import React, { Component } from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form';
import {    
    required,
    validarApenasNumero    
} from '../../util/inputs'
import { confirmarAutenticacaoDoisFatores, reenviarCodigoAutenticacaoDoisFatores } from '../../actions/util/authenticationJwtActions';
import { getAuthentication } from '../../security/securityContext';

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    // NOVO: Prop para receber a Ref (usaremos 'inputRef')
    inputRef, 
    // NOVO: Prop para receber o nosso onChange customizado
    customOnChange, 
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input 
                {...input} 
                type={type}
                className={css}
                maxLength={max || 2}
                id={input.name}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly}
                ref={inputRef}                
                onChange={customOnChange ? customOnChange : input.onChange} 
            />            
        </div>
        <div>
            {touched
                    && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class PainelAutenticacaoDoisFatores extends Component {

    constructor(props) {
        super(props);
        this.state = {            
            avisoMensagemEnvioEmail: false,
            // Definição das Refs e Ordem dos Campos
            // Crie Refs para todos os 5 campos
            refs:  {
                numero1: React.createRef(),
                numero2: React.createRef(),
                numero3: React.createRef(),
                numero4: React.createRef(),
                numero5: React.createRef(),
            },
            // Array para determinar a ordem de pulo
            fieldNames: ['numero1', 'numero2', 'numero3', 'numero4', 'numero5']
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {        
        const authentication = getAuthentication();
        if (!authentication) {
            window.location.href = '/'
            return;
        }
        
        const dataAlvoString = authentication.validadeAutenticacaoDoisFatores;
        const dataAlvo = new Date(dataAlvoString);
        const displayElement = document.getElementById('contador-autenticacao-dois-fatores');
        this.iniciarContador(dataAlvo, displayElement);
    }
    
    handleNextFocus = (currentFieldName, e, originalReduxFormChange) => {
        const value = e.target.value;

        // 🚨 Primeiro, chame o onChange original do Redux-Form 
        // para que o estado do formulário seja atualizado.
        originalReduxFormChange(e);
                
        if (value && value.length === 2) {
            const currentIndex = this.state.fieldNames.indexOf(currentFieldName);
            const nextFieldName = this.state.fieldNames[currentIndex + 1];

            // Se o próximo campo existir, foca nele usando a Ref
            if (nextFieldName) {
                const nextFieldRef = this.state.refs[nextFieldName];
                if (nextFieldRef && nextFieldRef.current) {
                    nextFieldRef.current.focus();
                }
            }
        }
    };
    
    // Função Wrapper para Injecer Refs e onChange (O prop 'component' usa esta função)
    wrapperRenderField = (fieldProps) => {
        const fieldName = fieldProps.input.name;
        
        return renderField({
            ...fieldProps,
            // Injeta a Ref do campo atual
            inputRef: this.state.refs[fieldName],
                        
            // Injeta o novo onChange que chama a lógica de pulo e o onChange original
            customOnChange: (e) => this.handleNextFocus(fieldName, e, fieldProps.input.onChange),
                        
            max: 2 
        });
    };

    iniciarContador(dataFim, elementoDisplay) {
        let dataAtual = new Date(); // Cria uma nova data para começar a contar do tempo atual
        let tempoRestanteMs = dataFim.getTime() - dataAtual.getTime();
    
        // Função que será executada a cada segundo
        const intervalId = setInterval(() => {
            tempoRestanteMs -= 1000;
            
            const minutos = Math.floor((tempoRestanteMs % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestanteMs % (1000 * 60)) / 1000);
    
            // Formata a saída (adiciona zero à esquerda se necessário)
            const formatar = num => String(num).padStart(2, '0');
    
            const saida = `Faltam: ${formatar(minutos)}m ${formatar(segundos)}s`;
    
            // Atualiza o elemento HTML (exemplo)
            if (elementoDisplay) {
                elementoDisplay.textContent = saida;
            } else {
                console.log(saida);
            }
                        
            if (tempoRestanteMs <= 0) {
                clearInterval(intervalId);
                window.location.href = '/'
                return;
            }
        }, 1000);
    }

    reenviarCodigo() {        
        const authentication = getAuthentication();
        this.props.reenviarCodigoAutenticacaoDoisFatores({
            emailUsuario: authentication.username
        }).then(() => {
            this.setState({avisoMensagemEnvioEmail: true});
            setTimeout(() => this.setState({avisoMensagemEnvioEmail: false }), 15000);
        })
    }

    submit(values) {       
        const authentication = getAuthentication();

        this.props.confirmarAutenticacaoDoisFatores({
            username: authentication.username,
            codigo: `${values.numero1}-${values.numero2}-${values.numero3}-${values.numero4}-${values.numero5}`,
            hash: authentication.hashAutenticaoDoisFatores
        });
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: '/' } };
        const { isAuthenticated } = this.props.authentication;

        const {
            handleSubmit, submitting, invalid
        } = this.props;

        if (isAuthenticated) {
            return (<Redirect to={from} />)
          }

        return (<div className="area-home" style={{marginTop: '20px'}}>
            <div className="alert alert-primary" role="alert">
                <p><strong>Foi enviada uma mensagem com um código de confirmação para o seu email.</strong></p>
            </div>
            <div id="contador-autenticacao-dois-fatores"></div>
            <div className="row home col-12">
                <h1>Autenticação de dois fatores</h1>                
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="row col-12 mb-2">
                    <div className="containerPageDoisFatores form-inline" style={{marginTop: '20px'}}>                    
                    <Field name="numero1" type="text" validate={[required, validarApenasNumero]} 
                        component={this.wrapperRenderField}
                        css="numeroAutenticacaoDoisFatores" readOnly={false} />
                    <Field name="numero2" type="text" validate={[required, validarApenasNumero]} 
                        component={this.wrapperRenderField}
                        css="numeroAutenticacaoDoisFatores" readOnly={false} />
                    <Field name="numero3" type="text" validate={[required, validarApenasNumero]} 
                        component={this.wrapperRenderField}
                        css="numeroAutenticacaoDoisFatores" readOnly={false} />
                    <Field name="numero4" type="text" validate={[required, validarApenasNumero]} 
                        component={this.wrapperRenderField}
                        css="numeroAutenticacaoDoisFatores" readOnly={false} />
                    <Field name="numero5" type="text" validate={[required, validarApenasNumero]} 
                        component={this.wrapperRenderField}
                        css="numeroAutenticacaoDoisFatores" readOnly={false} />
                    </div>
                </div>
                {this.state.avisoMensagemEnvioEmail &&<div className="row col-6 mt-2">
                    <p style={{color: 'red'}}>Aguarde 2 minutos, verifique a caixa de span do seu email.</p>
                </div>}
                <div className="row col-12">
                    <button className="btn btn-success mr-1" type="submit" 
                        disabled={invalid || submitting}>Confirmar</button>                    
                    <button type="button" className="btn btn-info"
                        disabled={this.state.avisoMensagemEnvioEmail}
                        onClick={() => this.reenviarCodigo()}>Reenviar</button>
                </div>
            </form>
        </div>)
    }
}

export const mapStateToProps = state => (
    {
        authentication: state.authentication,        

    });



export default withRouter(connect(mapStateToProps,
    {
        confirmarAutenticacaoDoisFatores,
        reenviarCodigoAutenticacaoDoisFatores
    })(reduxForm({
    form: 'formularioConfirmarAutenticacaoDoisFatores'
})(PainelAutenticacaoDoisFatores)))
